/* ============================================================
   LG CART UPSELL
   "Add More To Your Basket" — replaces Kaching Cart's upsell.

   WHY THIS EXISTS RATHER THAN A <product-form>
   --------------------------------------------------------
   Dawn's <product-form> cannot be used for controls that the cart drawer
   creates when it re-renders itself. Two things go wrong, both in the element
   constructor, which runs before the element's children are parsed:

     1. `this.form = this.querySelector('form')` is null, so Dawn's submit
        listener is never attached and the form does a NATIVE POST to
        /cart/add — redirecting the shopper to /cart and discarding the drawer
        they were standing in.
     2. `this.cart = document.querySelector('cart-drawer')` also resolves null,
        so even a working form would take product-form.js's no-cart branch and
        navigate to /cart anyway.

   The failure is invisible to assertions: the item IS added and no error is
   thrown. It only shows up in a screenshot of where the shopper ended up.

   So this talks to /cart/add.js directly and hands the response to the drawer's
   own renderContents() — the same path Dawn's form would have taken, minus the
   custom element.
   ============================================================ */
(function () {
  'use strict';

  /* ------------------------------------------------------------------
     WHICH SURFACE WAS CLICKED — ASK THE BUTTON, NOT THE DOCUMENT.

     `document.querySelector('cart-drawer')` is the obvious test and it is
     wrong. theme.liquid renders the drawer on EVERY template (line 333, gated
     only on `settings.cart_type`), so a hidden drawer sits in the DOM of /cart
     too. A document-level lookup therefore always finds one, and every click on
     the cart page took the drawer branch: renderContents() dutifully repainted
     the invisible drawer while the page the shopper was actually looking at —
     its totals, its meter, its line items — kept the values it loaded with.

     The item does get added, nothing throws, and the console stays clean. The
     only visible symptom is a basket that ignores you.

     Walking up from the button settles it: a button inside <cart-drawer> is a
     drawer button, anything else is a page button. The page then needs its own
     render path anyway, because Dawn's CartItems.onCartUpdate() refreshes only
     `main-cart-items` off the drawer — never `main-cart-footer`, which is where
     the meter and the totals live.
     ------------------------------------------------------------------ */
  function drawerFor(button) {
    return button.closest('cart-drawer');
  }

  function pageTargets() {
    var items = document.getElementById('main-cart-items');
    var footer = document.getElementById('main-cart-footer');
    if (!items || !footer) return null;

    /* `data-id` carries the real section id, which is whatever the template
       named the section ("cart-items"), not the element id. */
    return [
      { section: items.dataset.id, selector: '.js-contents', root: items },
      { section: footer.dataset.id, selector: '.js-contents', root: footer },
    ];
  }

  function renderPage(json, targets) {
    var parsed = new DOMParser();

    targets.forEach(function (t) {
      var html = json.sections && json.sections[t.section];
      if (!html) return;

      var doc = parsed.parseFromString(html, 'text/html');
      var source = doc.querySelector(t.selector);
      var target = t.root.querySelector(t.selector);
      if (source && target) target.innerHTML = source.innerHTML;
    });

    /* The header count is its own section and lives outside both roots. */
    var bubbleHtml = json.sections && json.sections['cart-icon-bubble'];
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubbleHtml && bubble) {
      var doc = parsed.parseFromString(bubbleHtml, 'text/html');
      var source = doc.querySelector('.shopify-section');
      if (source) bubble.innerHTML = source.innerHTML;
    }
  }

  async function addVariant(button) {
    var drawer = drawerFor(button);
    var targets = drawer ? null : pageTargets();
    var id = button.dataset.variantId;
    if ((!drawer && !targets) || !id) return;

    var label = button.querySelector('.lg-upsell__add-label');
    var original = label ? label.textContent : '';
    button.disabled = true;
    if (label) label.textContent = 'Adding…';

    try {
      /* Ask for the same sections the drawer would have asked for, so the
         response can be rendered without a second round trip. */
      var sections = drawer
        ? drawer.getSectionsToRender
          ? drawer.getSectionsToRender().map(function (s) {
              return s.id;
            })
          : []
        : targets
            .map(function (t) {
              return t.section;
            })
            .concat('cart-icon-bubble');

      var res = await fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify({
          items: [{ id: Number(id), quantity: 1 }],
          sections: sections,
          sections_url: window.location.pathname,
        }),
      });

      var json = await res.json();

      if (json.status) {
        if (label) label.textContent = json.description || 'Unavailable';
        button.disabled = false;
        return;
      }

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'lg-cart-upsell', cartData: json });
      }

      /* Both paths replace the markup containing this button, so nothing after
         this point may touch it. */
      if (drawer) {
        drawer.renderContents(json);
      } else {
        renderPage(json, targets);
      }
    } catch (e) {
      if (label) label.textContent = original || 'Add';
      button.disabled = false;
    }
  }

  /* Delegated, because the buttons are replaced on every cart change. */
  document.addEventListener('click', function (e) {
    var button = e.target.closest('[data-lg-upsell-add]');
    if (!button) return;
    e.preventDefault();
    addVariant(button);
  });
})();
